const { isNil } = require('lodash');

const TEST_VARIATION_A = 'test_variation_a';
const TEST_VARIATION_B = 'test_variation_b';
const TEST_VARIATION_C = 'test_variation_c';
const TEST_VARIATION_D = 'test_variation_d';

const variations = [TEST_VARIATION_B, TEST_VARIATION_C, TEST_VARIATION_D];

const convertTestVersion = (variation) => {
    if (isNil(variation) || variation === '0' || Number(variation) === 1) {
        return TEST_VARIATION_A;
    } else if (Number(variation) === 2) {
        return TEST_VARIATION_B;
    } else if (Number(variation) === 3) {
        return TEST_VARIATION_C;
    } else {
        return TEST_VARIATION_D;
    }
};

const getTestVariation = (abTests = {}, testNumber) => convertTestVersion(abTests[testNumber]);

const inAbTest = (abTests, testNumber) => variations.includes(getTestVariation(abTests, testNumber));

module.exports = {
    TEST_VARIATION_A,
    TEST_VARIATION_B,
    TEST_VARIATION_C,
    TEST_VARIATION_D,
    convertTestVersion,
    getTestVariation,
    inAbTest,
};
